module.exports = __webpack_public_path__ + "static/media/close.9b160e93.png";